import { createApp } from "vue"
import api from '../plugins/api';
import { plugin as Base } from '@apptegy/base';
import { plugin as Containers } from '@apptegy/containers';
import { plugin as Forms } from '@apptegy/forms';
import { plugin as Navigation } from '@apptegy/navigation';
import { plugin as Icons } from '@apptegy/icons';
import { plugin as Pagination } from '@apptegy/pagination';
import { plugin as Table } from '@apptegy/table';
import { VueIntl } from '@apptegy/vue-intl';
import analytics from '../plugins/amplitude'

import '@apptegy/styles';
import '@apptegy/base/dist/style.css';
import '@apptegy/containers/dist/style.css';
import '@apptegy/forms/dist/style.css';
import '@apptegy/navigation/dist/style.css';
import '@apptegy/pagination/dist/style.css';
import '@apptegy/table/dist/style.css';
import '@apptegy/table/dist/style.css';
import '@apptegy/notification/dist/style.css';

import en from '../locale/en.json';
import es from '../locale/es.json';
import formsLocale from '@apptegy/forms/locale/en.json'
import notificationLocale from '@apptegy/notification/locale/en.json'
import baseLocale from '@apptegy/base/locale/en.json'
import containersLocale from '@apptegy/containers/locale/en.json';
import navigationLocale from '@apptegy/navigation/locale/en.json';

import Notifications from '@kyvg/vue3-notification'
import ANotifications from '../components/Notifications/Notification.vue';
import Provider from "../components/Provider.vue"
import SignUp from "../components/Guardianships/SignUp.vue";
import Notify from "../components/Notify.vue";
import DistrictPicker from "../components/DistrictPicker.vue";

const app = createApp({
  components: {
    provider: Provider,
    GuardianshipSignUp: SignUp,
    notify: Notify,
    DistrictPicker
  },
  mounted(){
    this.$clients.initializeClients();
  }
})

app.use(api);
app.use(Base);
app.use(Containers);
app.use(Forms);
app.use(Navigation);
app.use(Icons);
app.component('ANotifications',ANotifications);
app.use(Notifications, {componentName: 'kyvg-notification'})
app.use(Pagination);
app.use(Table);
app.use(VueIntl, {
  defaultLocale: 'en',
  locales: [
    {
      code: 'en',
      messages: {
        ...en,
        dscl: { ...notificationLocale, ...baseLocale, ...formsLocale, ...containersLocale, ...navigationLocale },
      },
    },
    {
      code: 'es',
      messages: es
    },
  ],
});
app.use(analytics);
app.mount('#guardian_app_container')

